import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Switch } from "@/components/ui/switch";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { CATEGORIES } from "@/lib/shop";
import { PhotoField } from "./PhotoField";

const blank = { name: "", category: "iphone", condition: "A+ Used", storage: "", colour: "", price: "", image_url: "", description: "", in_stock: true, featured: false };

export const ProductForm = ({ product, onClose, onSave }) => {
  const [f, setF] = useState(blank);
  useEffect(() => { if (product) setF({ ...blank, ...product, price: product.price ?? "" }); }, [product]);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = (e) => {
    e.preventDefault();
    const { _id, created_at, ...rest } = f;
    onSave({ ...rest, image_url: f.image_url || null, price: f.price === "" ? null : Number(f.price), storage: f.storage || null, colour: f.colour || null, description: f.description || null });
  };

  return (
    <Dialog open={!!product} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="sm:max-w-lg max-h-[92vh] overflow-y-auto" data-testid="product-form-dialog">
        <DialogHeader><DialogTitle>{product?._id ? "Edit product" : "Add product"}</DialogTitle></DialogHeader>
        <form onSubmit={submit} className="grid gap-3">
          <Row label="Name"><Input required value={f.name} onChange={set("name")} data-testid="pf-name" /></Row>
          <div className="grid grid-cols-2 gap-3">
            <Row label="Category">
              <Select value={f.category} onValueChange={(v) => setF({ ...f, category: v })}>
                <SelectTrigger data-testid="pf-category"><SelectValue /></SelectTrigger>
                <SelectContent>{CATEGORIES.filter((c) => c.value !== "all").map((c) => <SelectItem key={c.value} value={c.value}>{c.label}</SelectItem>)}</SelectContent>
              </Select>
            </Row>
            <Row label="Condition">
              <Select value={f.condition} onValueChange={(v) => setF({ ...f, condition: v })}>
                <SelectTrigger data-testid="pf-condition"><SelectValue /></SelectTrigger>
                <SelectContent><SelectItem value="New">New</SelectItem><SelectItem value="A+ Used">A+ Used</SelectItem></SelectContent>
              </Select>
            </Row>
          </div>
          <div className="grid grid-cols-3 gap-3">
            <Row label="Price (£)"><Input type="number" step="0.01" min="0" value={f.price} onChange={set("price")} data-testid="pf-price" /></Row>
            <Row label="Storage"><Input value={f.storage || ""} onChange={set("storage")} data-testid="pf-storage" /></Row>
            <Row label="Colour"><Input value={f.colour || ""} onChange={set("colour")} data-testid="pf-colour" /></Row>
          </div>
          <PhotoField value={f.image_url} onChange={(url) => setF((cur) => ({ ...cur, image_url: url }))} />
          <Row label="Description"><Textarea rows={2} value={f.description || ""} onChange={set("description")} data-testid="pf-description" /></Row>
          <div className="flex gap-6">
            <label className="flex items-center gap-2 text-sm"><Switch checked={f.in_stock} onCheckedChange={(v) => setF({ ...f, in_stock: v })} data-testid="pf-instock" /> In stock</label>
            <label className="flex items-center gap-2 text-sm"><Switch checked={f.featured} onCheckedChange={(v) => setF({ ...f, featured: v })} data-testid="pf-featured" /> Show first</label>
          </div>
          <button className="mt-2 rounded-full bg-brand-600 py-3 font-bold text-white hover:bg-brand-700" data-testid="pf-save-btn">Save</button>
        </form>
      </DialogContent>
    </Dialog>
  );
};

const Row = ({ label, children }) => <div className="grid gap-1"><Label className="text-xs font-semibold">{label}</Label>{children}</div>;
